import { Colors } from 'basic-ui-lib';
import Sidebar from 'layouts/widgets/Sidebar';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';
import { useSidebar } from './useSidebar';

const SidebarLayout = () => {
  const { open } = useSidebar();

  return (
    <Container>
      {open &&
      <Sidebar />
      }
      <WrapperContent>
        <ContentScrollView>
          <Outlet />
        </ContentScrollView>
      </WrapperContent>
    </Container>
  );
};

export default SidebarLayout;

const Container = styled.div`
  display: flex;
  flex: 1;
`;

const WrapperContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: ${Colors.neutral.bg[2]};
  position: relative;
`;
const ContentScrollView = styled.div`
  position: absolute;
  inset: 0;
  overflow: auto;
  overflow: scroll;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`;
